import { render, staticRenderFns } from "./UserSummaryList.vue?vue&type=template&id=4fa2231f&scoped=true"
import script from "./UserSummaryList.vue?vue&type=script&lang=js"
export * from "./UserSummaryList.vue?vue&type=script&lang=js"
import style0 from "./UserSummaryList.vue?vue&type=style&index=0&id=4fa2231f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa2231f",
  null
  
)

export default component.exports